import 'rc-slider/assets/index.css';
import React, { useEffect, useRef, useState } from 'react';
import { getRandom, PresetData, presets } from './constants';
import { gridy } from './gridy';
import { BInstrument } from './instrument';
import { useWindowSize } from './utils/windowSizeDetect';

// ripping off this idea
// https://twitter.com/jagarikin/status/1388660839205326851?s=20

//const grid = gridy;

// const ins = instr();

// let health = 0;



// const draw = (ctx: CanvasRenderingContext2D) => {

//     drawGrid(ctx);

//     for (let i = 0; i < balls.length; i++) {
//         const b = balls[i];
//         b.draw(ctx);
//     }

// }


// the canvas size that all the presets are made for .. so we should scale to this
const optimalCanvas = { w: 900, h: 700 }

export const Bouncer = (props: {
    instrument: BInstrument
}) => {

    const [showPresets, setShowPresets] = useState(false);

    const w = useWindowSize();

    const makeNewGrid = (canvasW: number, canvasH: number, data: PresetData = presets[0].data) => gridy(
        canvasW, canvasH,
        data.boxes,
        data.dotCount,
        data.rhythm,
        data.rad * (((canvasW / optimalCanvas.w) + (canvasH / optimalCanvas.h)) / 2), // just avg the w/h ratio
        data.speed * (((canvasW / optimalCanvas.w) + (canvasH / optimalCanvas.h)) / 2),
        data.lives,
        props.instrument,
    )

    // const [instrument, setInstrument] = useState(undefined as undefined | BInstrument);
    // const instrumentRef = useRef(instrument);
    // instrumentRef.current = instrument;

    const [grid, setGrid] = useState(makeNewGrid(w.width, w.height));
    const gridRef = useRef(grid);
    gridRef.current = grid;

    const runTimer = (canvas: HTMLCanvasElement) => {
        const ctx = canvas.getContext("2d");

        function repeatOften() {
            if (!!ctx) gridRef.current.draw(ctx);
            requestAnimationFrame(repeatOften);
        }
        requestAnimationFrame(repeatOften);

    }


    useEffect(() => {
        // const ins = instr(() => {
        //     setInstrument(ins);
        // });

        const c = document.getElementById("bbb") as HTMLCanvasElement
        runTimer(c)
    }, [])

    useEffect(() => {
        gridRef.current.setCanvas(w.width, w.height)
    }, [w.width, w.height])

    return <div style={{ display: 'flex', flexDirection: "column" }}>
        <div style={{ position: "fixed", bottom: 20, right: 20, textAlign: "right" }}><a rel="noreferrer" href="https://twitter.com/keef_u" target="_blank">@keefu</a><br /><br /></div>
        <canvas onClick={() => setShowPresets(!showPresets)} id="bbb" width={w.width} height={w.height}></canvas>
        {/* <div><br /><Slider defaultValue={config.lives} onChange={v => config.lives = v} max={50} /></div> */}
        {showPresets &&
            <div className="overlay">
                {presets.map(p =>
                    <button key={p.name} type="button" onClick={() => {
                        setGrid(makeNewGrid(w.width, w.height, p.data));
                        setShowPresets(false);
                    }
                    }>{p.name}</button>
                )}
                <button type="button" onClick={() => {
                    setGrid(makeNewGrid(w.width, w.height, getRandom()));
                    setShowPresets(false);
                }
                }>RANDOM</button>

            </div>
        }
    </div>

}